import { Filter } from "@repo/icons";
import { useRouter, useSearch } from "@tanstack/react-router";
import { HeaderButton } from "@/components/header.tsx";
import { BadgeActiveFilter } from "@/components/badge-filter-status";

interface CommunityFilterButtonProps {
  align: "start" | "end";
}

export const CommunityFilterButton = ({
  align = "end",
}: CommunityFilterButtonProps): JSX.Element => {
  const router = useRouter();
  const params = useSearch({ from: "/settings/community/" });

  const hasAnyFilterApplied = Boolean(params.specialties) || Boolean(params.locations);

  const handleOpenFilterDrawer = (): void => {
    void router.navigate({
      search: {
        ...params,
        action: "filter-drawer",
      },
    });
  };

  return (
    <div className="relative flex items-center">
      <HeaderButton
        onClick={handleOpenFilterDrawer}
        icon={Filter}
        align={align}
        aria-label="Filter button"
      />

      {hasAnyFilterApplied ? <BadgeActiveFilter /> : null}
    </div>
  );
};
